import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';

@Component({
    selector: 'app-edit-tipo',
    templateUrl: './edit-tipo.component.html',
    styleUrls: ['./edit-tipo.component.css'],
    standalone: false
})
export class EditTipoComponent implements OnInit {

  form: UntypedFormGroup;
  nombre: string = "";

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EditTipoComponent>) { }

  ngOnInit(): void {
    this.nombre = this.data['nombre'];
    this.form = this.fb.group({
      nombre: [this.nombre, [Validators.required, Validators.minLength(1), Validators.maxLength(32)]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
